export const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escape(string: string) {
  const reUnescapedHtml = /[&<>"']/g

  if (reUnescapedHtml.test(string)) {
    return string.replace(reUnescapedHtml, (char) => HTML_ESCAPES[char])
  }

  return string
}
